import React from "react";
import { Box } from "@mui/material";
import Page from "../../components/Page";

const HEADER_HEIGHT = "var(--layout-header-height, 80px)";

const heroPanelSx = {
  flex: { md: "1 1 50%" },
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: { xs: 2, sm: 3, md: 4 },
  py: { xs: 2, sm: 3, md: 5 },
  minHeight: { xs: "auto", sm: 300, lg: "auto" },
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundColor: "var(--color-auth-overlay, rgba(0, 0, 0, 0.5))",
    zIndex: 0,
  },
};

const heroCardSx = {
  position: "relative",
  zIndex: 1,
  width: "100%",
  backgroundColor: "var(--color-bg-card, #ffffff)",
  borderRadius: "20px",
  boxShadow: "var(--shadow-card-hover, 0 4px 10px rgba(0, 0, 0, 0.2))",
  px: { xs: 2.5, sm: 4, md: "60px" },
  py: { xs: 3, sm: 4, md: "80px" },
};

const formPanelSx = {
  flex: { md: "1 1 50%" },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: { xs: 2, sm: 3, md: 4 },
  py: { xs: 3, sm: 4, md: 4 },
  background: "var(--color-bg-surface, var(--color-bg-page, #f5f5f5))",
};

const AuthSplitPage = ({
  className,
  hero,
  form,
  heroBackgroundImage,
  heroCardMaxWidth = 640,
  formContentMaxWidth = 400,
  heroPanelSx: heroPanelOverrides,
  heroCardSx: heroCardOverrides,
  formPanelSx: formPanelOverrides,
  formContentSx,
  formFirstOnMobile = true,
}) => (
  <Page>
    <Box
      className={className}
      sx={{
        minHeight: "100vh",
        pt: HEADER_HEIGHT,
        backgroundColor: "var(--color-bg-page, #f5f5f5)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          minHeight: { xs: "auto", md: `calc(100vh - ${HEADER_HEIGHT})` },
        }}
      >
        <Box
          className="authSplitPage__heroPanel"
          sx={[
            heroPanelSx,
            {
              order: { xs: formFirstOnMobile ? 2 : 1, md: 1 },
              backgroundImage: `url(${heroBackgroundImage})`,
            },
            heroPanelOverrides,
          ]}
        >
          <Box
            className="authSplitPage__heroCard"
            sx={[
              heroCardSx,
              {
                maxWidth: heroCardMaxWidth,
                textAlign: "center",
              },
              heroCardOverrides,
            ]}
          >
            {hero}
          </Box>
        </Box>
        <Box
          sx={[
            formPanelSx,
            {
              order: { xs: formFirstOnMobile ? 1 : 2, md: 2 },
            },
            formPanelOverrides,
          ]}
        >
          <Box
            sx={[
              {
                width: "100%",
                maxWidth: formContentMaxWidth,
              },
              formContentSx,
            ]}
          >
            {form}
          </Box>
        </Box>
      </Box>
    </Box>
  </Page>
);

export default AuthSplitPage;
